<template>
  <div id="RentalPage">
    <rental-section />
  </div>
</template>

<script>
// @ is an alias to /src
import RentalSection from "@/components/RentalSection";

export default {
  name: "RentalPage",
  components: {
    RentalSection
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
